module.exports = __webpack_public_path__ + "static/media/206-gallery14.3905936d.jpg";